import input from './input'
export {input}
export default {
  input
}
